import Skeleton from '@mui/material/Skeleton';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function SkeletonFull() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Skeleton
      animation="wave"
      variant="rectangular"
      width="100%"
      height={isMobile ? '240px' : '350px'}
    />
  );
}

export default SkeletonFull;
